/**
 * This class is used to bind to the login form.
 */
export class LoginModel {

	public Email: string;

	public Password: string;

}